// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"fb5ea667","233":"170f6ef4","236":"5dd3446d","243":"63cca695"}[chunkId] + ".chunk.js";
};